import { accessDBApi } from './api';
import type {
  ApiResponse,
  DomainSummary,
  DomainDetail,
  DomainSettings,
  DomainStatus
} from '../types';

export interface CreateDomainRequest {
  domain: string;
  description?: string;
}

export interface CreateDomainResponse {
  id: string;
  domain: string;
  api_key: string;
  status: DomainStatus;
  created_at: string;
}

export interface UpdateDomainRequest {
  description?: string;
  status?: DomainStatus;
  model_id?: string;
  settings?: Partial<DomainSettings>;
  crawl_schedule?: 'off' | 'daily' | 'weekly' | 'monthly';
}

export interface DomainListParams {
  page?: number;
  limit?: number;
  status?: 'active' | 'inactive' | 'all';
  search?: string;
}

export const domainService = {
  // ドメイン一覧取得
  getDomains: async (
    params?: DomainListParams,
    options?: { skipGlobalErrorToast?: boolean },
  ): Promise<ApiResponse<DomainSummary[]>> => {
    const response = await accessDBApi.get('/v1/domains', { params, ...options });
    return response.data;
  },

  // ドメイン詳細取得
  getDomain: async (id: string): Promise<ApiResponse<DomainDetail>> => {
    const response = await accessDBApi.get(`/v1/domains/${id}`);
    return response.data;
  },

  // ドメイン作成
  createDomain: async (data: CreateDomainRequest): Promise<ApiResponse<CreateDomainResponse>> => {
    const response = await accessDBApi.post('/v1/domains', data, { skipGlobalErrorToast: true });
    return response.data;
  },

  // ドメイン更新
  updateDomain: async (id: string, data: UpdateDomainRequest): Promise<ApiResponse<DomainDetail>> => {
    const response = await accessDBApi.put(`/v1/domains/${id}`, data);
    return response.data;
  },

  // ドメイン削除
  deleteDomain: async (id: string): Promise<ApiResponse<{ message: string }>> => {
    const response = await accessDBApi.delete(`/v1/domains/${id}`);
    return response.data;
  },

  // APIキー再生成
  regenerateApiKey: async (id: string): Promise<ApiResponse<{ api_key: string }>> => {
    const response = await accessDBApi.post(`/v1/domains/${id}/regenerate-key`);
    return response.data;
  },

  // ロゴアップロード
  uploadLogo: async (id: string, file: File): Promise<ApiResponse<{ logo_url: string }>> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await accessDBApi.post(`/v1/domains/${id}/logo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // ロゴ削除
  deleteLogo: async (id: string): Promise<ApiResponse<{ message: string }>> => {
    const response = await accessDBApi.delete(`/v1/domains/${id}/logo`);
    return response.data;
  },
};
